import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {LookupModel} from '../../api/models/lookup-model';
import {RRule, Frequency} from 'rrule';
import {DateTime} from 'luxon';
import {DateUtils} from '../../core/utilities/date-time-helpers';
import {Subscription} from 'rxjs';
import { MatDatetimeInputComponent } from '../mat-datetime-input/mat-datetime-input.component';
import { FlexModule } from '@angular/flex-layout';
import { MatSimpleSelectComponent } from '../mat-simple-select/mat-simple-select.component';
import { MatNumberInputComponent } from '../mat-number-input/mat-number-input.component';
import { NgIf } from '@angular/common';
import { MatMultiselectComponent } from '../mat-multiselect-input/mat-multiselect.component';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatDateInputComponent } from '../mat-date-input/mat-date-input.component';
import { RepeatFrequencyTextPipe } from '../../core/pipes/repeat-frequency-text.pipe';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';

@Component({
    selector: 'app-mat-rrule-form-group',
    template: `
    <div class="flex-row">
      <app-mat-datetime-input [formControl]="getFormControl('dtstart')"
                              label="Initial Date"
      ></app-mat-datetime-input>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <app-mat-simple-select [formControl]="getFormControl('freq')"
                             name="freq" label="Repeat"
                             style="min-width: 115px"
                             [selectItems]="freqList"
                             [submitted]="submitted">
      </app-mat-simple-select>
      <label>every</label>
      <app-mat-number-input [formControl]="getFormControl('interval')"
                            name="interval"
                            style="width: 80px"
                            [min]="1"
                            [submitted]="submitted"></app-mat-number-input>
      <label>{{formGroup.get('freq').value | repeatFrequencyText}}</label>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <app-mat-multiselect [formControl]="getFormControl('byDay')"
                           *ngIf="formGroup.get('freq').value == 2"
                           [autoCompleteValues]="weekDays"
                           label="Week Days" name="byDay" placeholder="week days"
                           [submitted]="submitted"></app-mat-multiselect>
    </div>
    <mat-radio-group [formControl]="getFormControl('monthlyType')" *ngIf="formGroup.get('freq').value == 1">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-radio-button value="bymonthday" [disabled]="submitted">on day</mat-radio-button>
        <app-mat-simple-select [formControl]="getFormControl('byMonthDay')"
                               style="min-width: 100px"
                               placeholder="day"
                               name="byMonthDay" [hideLabel]="true"
                               [selectItems]="daysList" [submitted]="submitted">
        </app-mat-simple-select>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-radio-button value="bysetpos" [disabled]="submitted">on the</mat-radio-button>
        <app-mat-simple-select [formControl]="getFormControl('bySetPos')"
                               name="bySetPos"
                               style="min-width: 100px"
                               placeholder="which"
                               [hideLabel]="true"
                               [selectItems]="dayPosList"
                               [submitted]="submitted">
        </app-mat-simple-select>
        <app-mat-multiselect [formControl]="getFormControl('byDay')"
                             [autoCompleteValues]="weekDays"
                             label="Week Days" name="byDay" placeholder="week days"
                             [submitted]="submitted"></app-mat-multiselect>
      </div>
    </mat-radio-group>

    <mat-radio-group [formControl]="getFormControl('yearlyType')" *ngIf="formGroup.get('freq').value == 0">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-radio-button value="bymonthday" [disabled]="submitted">on</mat-radio-button>
        <app-mat-simple-select [formControl]="getFormControl('byMonth')"
                               name="byMonth"
                               style="min-width: 100px"
                               placeholder="month"
                               [hideLabel]="true"
                               [selectItems]="months"
                               [submitted]="submitted">
        </app-mat-simple-select>
        <app-mat-simple-select [formControl]="getFormControl('byMonthDay')"
                               name="byMonthDay"
                               style="min-width: 100px"
                               placeholder="day"
                               [hideLabel]="true"
                               [selectItems]="daysList"
                               [submitted]="submitted">
        </app-mat-simple-select>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-radio-button value="bysetpos" [disabled]="submitted">on the</mat-radio-button>
        <app-mat-simple-select [formControl]="getFormControl('bySetPos')"
                               name="bySetPos"
                               placeholder="which"
                               style="min-width: 115px"
                               [hideLabel]="true"
                               [selectItems]="dayPosList"
                               [submitted]="submitted">
        </app-mat-simple-select>
        <app-mat-multiselect [formControl]="getFormControl('byDay')"
                             [autoCompleteValues]="weekDays"
                             [hideLabel]="true"
                             label="Week Days" name="byDay" placeholder="week days"
                             [submitted]="submitted"></app-mat-multiselect>
        <label>of</label>
        <app-mat-simple-select [formControl]="getFormControl('byMonth')"
                               name="byMonth"
                               placeholder="month"
                               style="min-width: 115px"
                               [hideLabel]="true"
                               [selectItems]="months"
                               [submitted]="submitted">
        </app-mat-simple-select>
      </div>
    </mat-radio-group>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <app-mat-simple-select [formControl]="getFormControl('endType')"
                             name="endType"
                             style="min-width: 115px"
                             label="End"
                             [selectItems]="endTypes"
                             [submitted]="submitted">
      </app-mat-simple-select>
      <app-mat-number-input [formControl]="getFormControl('count')"
                            *ngIf="formGroup.get('endType').value === 1"
                            name="count" [min]="1"
                            style="width: 80px"
                            [submitted]="submitted"></app-mat-number-input>
      <label *ngIf="formGroup.get('endType').value === 1">
        {{formGroup.get('count')!.value === 1 ? 'time' : 'times'}}
      </label>
      <app-mat-date-input *ngIf="formGroup.get('endType').value === 2"
                          [formControl]="getFormControl('until')"></app-mat-date-input>
    </div>

    <div class="recurring-description">
      {{recurringText}}<br>
      Next Recurring will occur at {{recurringNextDate | dateTime}}
    </div>`,
    styles: [],
    standalone: true,
    imports: [MatDatetimeInputComponent, FormsModule, ReactiveFormsModule, FlexModule, MatSimpleSelectComponent, MatNumberInputComponent, NgIf, MatMultiselectComponent, MatRadioGroup, MatRadioButton, MatDateInputComponent, RepeatFrequencyTextPipe, DateTimePipe]
})
export class MatRruleFormGroupComponent implements OnChanges, OnDestroy {

  @Input() formGroup: UntypedFormGroup;
  @Input() submitted: boolean;
  @Input() userTimezone = 'America/New_York';
  @Output() onRRuleChanged = new EventEmitter<[RRule, Date]>();

  formValuesSubscription: Subscription;
  recurringText = 'Repeat';
  recurringNextDate: Date;

  freqList: LookupModel[] = [
    {text: 'Yearly', id: Frequency.YEARLY},
    {text: 'Monthly', id: Frequency.MONTHLY},
    {text: 'Weekly', id: Frequency.WEEKLY},
    {text: 'Daily', id: Frequency.DAILY},
    // {text: 'Hourly', value: Frequency.HOURLY}
  ];
  weekDays: LookupModel[] = [
    {text: 'Mon', id: RRule.MO.weekday},
    {text: 'Tue', id: RRule.TU.weekday},
    {text: 'Wed', id: RRule.WE.weekday},
    {text: 'Thu', id: RRule.TH.weekday},
    {text: 'Fri', id: RRule.FR.weekday},
    {text: 'Sat', id: RRule.SA.weekday},
    {text: 'Sun', id: RRule.SU.weekday}
  ];
  months: LookupModel[] = [
    {text: 'Jan', id: 1},
    {text: 'Feb', id: 2},
    {text: 'Mar', id: 3},
    {text: 'Apr', id: 4},
    {text: 'May', id: 5},
    {text: 'Jun', id: 6},
    {text: 'Jul', id: 7},
    {text: 'Aug', id: 8},
    {text: 'Sep', id: 9},
    {text: 'Oct', id: 10},
    {text: 'Nov', id: 11},
    {text: 'Dec', id: 12},
  ];
  dayPosList: LookupModel[] = [
    {text: 'First', id: 1},
    {text: 'Second', id: 2},
    {text: 'Third', id: 3},
    {text: 'Fourth', id: 4},
    {text: 'Last', id: -1},
  ];
  endTypes: LookupModel[] = [
    {text: 'Never', id: -1},
    {text: 'After', id: 1},
    {text: 'On Date', id: 2},
  ];
  daysList: LookupModel[] = [];

  constructor() {
    this.daysList = [];
    for (let i = 1; i < 32; i++) {
      this.daysList.push({text: `${i}`, id: i});
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formGroup']) {
      this.formValuesSubscription?.unsubscribe();
      this.formValuesSubscription = this.formGroup.valueChanges.subscribe(formValues => {
        console.log('form', JSON.stringify(formValues));
        if (this.formGroup.invalid) {
          return;
        }

        const recurring = formValues;

        let dtstart = recurring.dtstart || undefined;
        if (recurring.dtstart) {
          dtstart = DateTime.fromJSDate(recurring.dtstart, {zone: this.userTimezone}).toLocal().toJSDate();
          dtstart = DateUtils.localDateToDateTime(dtstart).toJSDate();
        }

        const lastDtStart = dtstart ? new Date(
          Date.UTC(
            dtstart.getUTCFullYear(),
            dtstart.getUTCMonth(),
            dtstart.getUTCDate(),
            dtstart.getUTCHours(),
            dtstart.getUTCMinutes(),
          )
        ) : undefined;
        console.log('lastDtStart', lastDtStart);

        let until = recurring.until || undefined;
        if (recurring.until) {
          until = DateUtils.localDateToDateTime(until).toJSDate();
        }

        const lastUntil = until ? new Date(
          Date.UTC(
            until.getUTCFullYear(),
            until.getUTCMonth(),
            until.getUTCDate(),
            dtstart.getUTCHours(),
            dtstart.getUTCMinutes(),
          )
        ) : undefined;
        console.log('lastUntil', lastDtStart);

        const isFreqValid = Object.values(Frequency).includes(recurring?.freq)

        if (!isFreqValid || !recurring.interval) {
          return;
        }

        const rule = new RRule({
          freq: recurring.freq,
          interval: recurring.interval,
          // tzid: userZone,
          dtstart: lastDtStart,

          byweekday: (recurring.freq === Frequency.WEEKLY && recurring.byDay)
          || (recurring.freq === Frequency.MONTHLY && recurring.monthlyType === 'bysetpos' && recurring.byDay)
          || (recurring.freq === Frequency.YEARLY && recurring.yearlyType === 'bysetpos' && recurring.byDay)
            ? recurring.byDay : undefined,
          bymonthday: (recurring.freq === Frequency.MONTHLY && recurring.monthlyType === 'bymonthday')
          || (recurring.freq === Frequency.YEARLY && recurring.yearlyType === 'bymonthday')
            ? recurring.byMonthDay : undefined,
          bysetpos: (recurring.freq === Frequency.MONTHLY && recurring.monthlyType === 'bysetpos')
          || (recurring.freq === Frequency.YEARLY && recurring.yearlyType === 'bysetpos')
            ? recurring.bySetPos : undefined,

          bymonth: recurring.freq === Frequency.YEARLY ? recurring.byMonth : undefined,

          count: recurring.endType === 1 ? recurring.count : undefined,
          until: recurring.endType === 2 ? lastUntil : undefined,
        });

        console.log('rrule', rule);
        this.recurringText = 'Repeat ' + rule.toText();

        // fix daylight saving time, keep same hour
        const customerInitialDate = DateTime.fromJSDate(dtstart).setZone(this.userTimezone, {keepLocalTime: true}); // .toUTC();
        const dateInFuture = DateTime.local().setZone(this.userTimezone).set({hour: customerInitialDate.hour}); // .toUTC();
        const customerInitialDateHour = customerInitialDate.toUTC().hour;
        const dateInFutureHour = dateInFuture.toUTC().hour;
        let hourDelta = 0;
        if (customerInitialDateHour !== dateInFutureHour) {
          hourDelta = customerInitialDateHour - dateInFutureHour;
        }
        console.log(customerInitialDate.toUTC().hour, dateInFuture.toUTC().hour, hourDelta);

        const dateNow = DateTime.local().setZone(this.userTimezone).toUTC();
        const startDate = new Date(
          Date.UTC(
            dateNow.year,
            dateNow.month - 1,
            dateNow.day,
            dateNow.hour + hourDelta,
            dateNow.minute,
          )
        );
        let nextDate = rule.after(startDate, true);

        console.log('nextDate', nextDate);

        if (lastDtStart && nextDate) {
          const customerInitialDate1 = DateTime.fromJSDate(lastDtStart).setZone(this.userTimezone);
          const customerNextDate = DateTime.fromJSDate(nextDate).setZone(this.userTimezone);

          if (customerInitialDate1.hour !== customerNextDate.hour) {
            const fixedNextDate = customerNextDate.set({hour: customerInitialDate1.hour});
            console.log(`Initial hour ${customerInitialDate1.hour} next hour ${customerNextDate.hour}`);
            // nextDate.setHours(lastDtStart.getHours());
            nextDate = fixedNextDate.toJSDate();
          }
        }

        this.recurringNextDate = nextDate;
        this.onRRuleChanged.emit([rule, nextDate]);
      });
    }
  }

  getFormControl(controlName: string): UntypedFormControl | undefined {
    if (this.formGroup) {
      return this.formGroup.get(controlName) as UntypedFormControl;
    }
    return undefined;
  }

  ngOnDestroy(): void {
    this.formValuesSubscription?.unsubscribe();
  }

}
